<template>
  <main id="vendors-list" class="site-main">
    <div class="grid-container">
      <div class="page-header grid-x grid-padding-x align-middle">
        <div class="cell auto">
          <h1 class="page-header__title">Payouts</h1>

          <div class="text-right">
            <span class="icon-action" @click="exportPayouts">
              <i class="far fa-arrow-to-bottom"></i> <span>Export</span>
            </span>
          </div>
        </div>
      </div>

      <div class="panel no-padding">
        <searchBar placeholder="Search payouts" @sort="sort"
                   :value="searchValue"
                   @search="search"></searchBar>

        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total"
                        @paginate="paginate"></pagination>

            <tableList :header="tableHeader" :data="tableData"
                       :loading="loading" @callback="callback"
                       @post="go" @sort="orderBy"></tableList>

            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total"
                        @paginate="paginate"></pagination>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import {APP, API_ROOT_URL} from '@/localSettings'

import moment from 'moment'
import axios from 'axios'

export default {
  name: 'ordersList',
  mixins: [client, paginationUtils],
  data: function () {
    return {
      action: '/vendors/payouts/',
      sort: '-invoice_number',
      tableHeader: {
        currentSort: '-invoice_number',
        data: [
          {
            label: 'Invoice #',
            class: 'medium'
          },
          {
            label: 'Amount',
            class: 'medium'
          },
          {
            label: 'Vendor',
            class: 'large'
          },
          {
            label: 'Note',
            class: 'full'
          },
          {
            label: 'Date',
            class: 'large'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    exportPayouts () {
      this.loading = true

      this.request('get', '/vendors/payouts/', {
        ordering: '-created_date',
        page_size: 1000,
        format: 'csv'
      }).then((response) => {
        let downloadLink = document.createElement('a')

        downloadLink.href = response
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        this.loading = false
      })
    },
    downloadReport (id) {
      axios({
        method: 'post',
        url: API_ROOT_URL + '/vendors/export-payout/?id=' + id
      }).then((response) => {
        if (response.status === 200) {
          let link = document.createElement('a')
          link.download = 'payout.pdf'
          link.href = response.data
          link.target = '_blank'
          link.textContent = 'Download payouts.csv'

          link.click()
        }
      })
    },
    go: function (id) {
      this.$router.push('/payouts/' + id)
    },
    buildTable () {
      if (APP === 'consignment') {
        this.tableHeader.data.push({
          label: '',
          class: 'medium'
        })
      }

      for (let i = 0; i < this.data.length; i++) {
        let row = {
          post: this.data[i].id,
          data: [
            {
              value: this.data[i].invoice_number,
              class: 'medium focus-text'
            },
            {
              value: this.formatMoney(this.data[i].amount),
              class: 'medium focus-text'
            },
            {
              value: this.data[i].vendor_name,
              class: 'large'
            },
            {
              value: this.data[i].note,
              class: 'full'
            },
            {
              value: moment(this.data[i].created_date).format('MMM D, YYYY [at] h:mma'),
              class: 'large'
            }
          ]
        }

        if (APP === 'consignment') {
          row.data.push({
            value: '<button class="button--small">Print Invoice</button>',
            class: 'medium',
            callback: 'downloadReport',
            callbackArgs: [this.data[i].id]
          })
        }

        this.tableData.push(row)
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/pages/payouts/list.vue